import {
  EntidadesFinancieras,
  Estudios,
  Multiservicios,
  Salud,
  Seguros,
  Servicios,
  SolicitudConvenios,
  Transportes,
} from "../pdfs";

export const pdfList = [
  {
    id: "salud",
    title: "Convenios Salud",
    src: Salud,
    drive:
      "https://drive.google.com/file/d/1hUDli6AX5kGJgcpgtKvGZrFfw7j2leAf/view?usp=drive_link",
  },
  {
    id: "transportes",
    title: "Convenios Transportes",
    src: Transportes,
    drive:
      "https://drive.google.com/file/d/1Rhx9bzkZqExfVbdf6ARNTeK73FT7xMzK/view?usp=drive_link",
  },
  {
    id: "servicios",
    title: "Convenios Servicios",
    src: Servicios,
    drive:
      "https://drive.google.com/file/d/1LyviSWdHnCmEUu7G6j3w3oGJA09YhH8t/view?usp=sharing",
  },
  {
    id: "seguros",
    title: "Convenios Seguros",
    src: Seguros,
    drive:
      "https://drive.google.com/file/d/1DVewl2rcBzBn4Lbk9tRxePVhmk2CS_Nu/view?usp=drive_link",
  },
  {
    id: "entidadesFinancieras",
    title: "Convenios Entidades Financieras",
    src: EntidadesFinancieras,
    drive:
      "https://drive.google.com/file/d/1lyQbfoOoX94OkFl2v_d993yyBoGvBRTk/view?usp=drive_link",
  },
  {
    id: "estudios",
    title: "Convenios Universidades e Institutos",
    src: Estudios,
    drive:
      "https://drive.google.com/file/d/1hYjBogSIqI8-1Xni16KOH-j28nF4YEsT/view?usp=sharing",
  },
  {
    id: "multiservicios",
    title: "Convenios Multiservicios",
    src: Multiservicios,
    drive:
      "https://drive.google.com/file/d/1_d0DUhTCu-fX_Sza4QjVHxB5tf0P2L8Z/view?usp=drive_link",
  },

  {
    id: "solicitudConvenios",
    title: "Solicitud de Convenios",
    src: SolicitudConvenios,
    drive:
      "https://drive.google.com/file/d/1TxueZ-lJlf0_zHZsQVmcZJQEa1biZLky/view?usp=sharing",
  },
];
